const CardPaymentDetails = ({ dataCard }) => {
  const payment = dataCard?.listPyaments?.[0];

  const rawAmount = parseFloat(payment?.paymentData?.amount ?? 0);
  const formattedAmount = rawAmount.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
  });

  const brand = payment?.paymentRuleData?.payment_type?.brand || 'Tarjeta';

  const method =
    payment?.paymentRuleData?.payment_type?.payment_method_type || '';

  const lastDigits = payment?.paymentData?.last_digits || '****';

  const installments =
    payment?.paymentRuleData?.installment?.number_of_payments || 1;

  const installmentsLabel = `${installments} cuota${
    installments > 1 ? 's' : ''
  }`;

  return (
    <span>
      Tu compra fue por un total de <b>${formattedAmount}</b> con tarjeta{' '}
      <b>{brand}</b>{' '}
      <span style={{ textTransform: 'capitalize' }}>{method}</span>, últimos 4
      dígitos: <b>{lastDigits}</b>, en <b>{installmentsLabel}</b>.
    </span>
  );
};

export default CardPaymentDetails;
